import { NextPage } from 'next';

import {
  Provider as ApplicationProvider,
  NewPage,
} from 'modules/application/core';
import { Page, PageLoading } from 'modules/common/layout';
import { AuthorizedOnly } from 'modules/common/auth';
import { Provider as LoanProvider } from 'modules/loan';

/**
 * Служебная страница, которая, если это возможно, создаёт заявку и
 * перенаправляет пользователя на первый шаг её заполнения.
 */
const New: NextPage = () => (
  <Page>
    <AuthorizedOnly fallback={<PageLoading />}>
      <ApplicationProvider>
        <LoanProvider>
          <NewPage />
        </LoanProvider>
      </ApplicationProvider>
    </AuthorizedOnly>
  </Page>
);

export default New;
